import meta from '@/assets/images/networks/meta.svg';

export default {
  name: 'META',
  name_long: 'Metadium',
  homePage: 'https://www.metadium.com',
  blockExplorerTX: 'https://explorer.metadium.com/tx/[[txHash]]',
  blockExplorerAddr: 'https://explorer.metadium.com/address/[[address]]',
  chainID: 11,
  tokens: [],
  contracts: [],
  icon: meta,
  currencyName: 'META'
};
